/* src/app/standort/standort.component.css */
/*# sourceMappingURL=standort.component-N2UWHUM3.css.map */
